import axios from "axios";
import {authtoken} from '@/values/private';

export default {
  namespaced: true,
  state: {
    isReceiving: null
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
  },
  actions: {
    async getFileDownload({dispatch}, url) {
      try{
        dispatch("doNothing");
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken};
        let response = await axios({method: "get", url: url, headers: headers, responseType: 'blob'});
      
        //let data = await response.data.blob();
        let blob = new Blob([response.data], { type: 'application/pdf' });

        let file = URL.createObjectURL(blob);
        return file;
      }
      catch(e){
        return null;
      }

    },
    async getPaySatementViewRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'http://localhost:8080/#/print/paystatement/' + id;
        
        let headers = {'Access-Control-Allow-Origin': '*', 'Content-Type': 'text/html'};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getShiftScheduleRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.tradexc.com:3000/view-api/get/shiftschedule/' + id;
        console.log(url)
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getSalesOrderViewRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
      
        let url = `http://localhost:8080/#/print/salesorder/${id}`;
        console.log(url);
        let headers = {'Content-Type': 'text/html; charset=UTF-8'};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getCompanyDataRequest({dispatch}, id) {
      dispatch("doNothing");
      let url = 'https://api.tradexc.com:3010/print-api/get/company/data/' + id;
      let headers = {'Content-Type': 'application/json', 'authtoken': authtoken};
      let response = await axios({method: "get", url: url, headers: headers});
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING");
    },
  },
};
